<template>
  <div class="main" :class="{backColorB: bCb}" @click="clearRightMenu"
       @click.right="clearRightMenu">
    <div class="editor-header-top">
      <editor-header></editor-header>
    </div>
    <!-- <editorHeader :isBack="isBack" :saveHint="saveHint" :bCb="bCb" :progress="progress" :queryData="queryData"/> -->
    <editorTop :taskTypeNames='taskTypeName' :queryDatas="queryData" :bCb="bCb"
               :isSeekBoxs="isSeekBox" :isSplits="isSplit" :ifSubmits="ifSubmit"
               :termSubmits="termSubmit" :isSourceEds="isSourceEd" :roleLevel="roleLevel"
               :interpreteruids="interpreteruid" @visionPattern="visionPattern"
               :sentenceShows="sentenceShow" @splitSentence="splitSentence"
               @mergeSentence="mergeSentence" @seekShow="seekShow" @rigBoxShow="rigBoxShow"
               @sizeEnlarge="sizeEnlarge" @sizeNarrow="sizeNarrow" @submit="submit"
               @setTermSent="setTermSent" @copySource="copySource" @anewTranslate="anewTranslate"
               @changeFilter="changeFilter" @sourceEditor="sourceEditor"
               @reTranslate="reTranslation" @interpreterTask="interpreterTask"
               @interpreterTaskOut="interpreterTaskOut" @toTaskIndex="toTaskIndex"
               @changeIsSplit="changeIsSplit" @isflag="isflag" @closeFlag="closeFlag"
               :states="state" />
    <div id="bagBox">
      <div class="box cat-trans" id="redactBox" ref="redactBox">
        <div v-show="fileShow&&((queryData.sourceLang)!=='mno'&&(queryData.targetLang)!=='mno')"
             class="cen" id="translation" ref="viewBox2">
          <iframe v-if="(fileShow==1)" width="100%" height="100%" frameborder="0" name="iframeBox"
                  id="editorIframe" :src="iframeSrc" />
          <div class="lef" ref="viewBox" id="sourceText" @mouseout="styleOut($event)"
               @contextmenu="oncontextmenu" max="15">
            <div ref="sourceBox" v-for="(item, index) in sourceList" :key="index" v-html="item" />
          </div>

        </div>

        <div id="tabBox"
             :style="(fileShow&&((queryData.sourceLang)!=='mno'&&(queryData.targetLang)!=='mno')) ? 'height:46%' : 'height:100%;top:0'">

          <!--蒙语显示视图-->
          <!--    v-if="((queryData.sourceLang)==='mno'||(queryData.targetLang)==='mno')" -->
          <mongolianLang ref="refTable"
                         v-if="((queryData.sourceLang)==='mno'||(queryData.targetLang)==='mno')"
                         :tableData="tableData" :data="tableData" :ifRepeatLock="ifRepeatLock"
                         :queryData="queryData" @pitchOn="pitchOn"
                         @sourceChangeText="sourceChangeText" @onFocus="onFocus"
                         @sourceBlur="sourceBlur" @getCursortPosition="getCursortPosition"
                         @oncontextmenu="oncontextmenu" @AutoComple="AutoComple"
                         @blurText="blurText" @getHint="getHint" @enterKey="enterKey" :bCb="bCb"
                         :isSourceid="isSourceid" @statusTit="statusTit" @onAddPostil="onAddPostil"
                         @homologous="homologous" />

        </div>

      </div>
      <div class="rigContantBox" ref="rigContantBox">
        <i class="icon-left riBoxSw" v-show="RigBoxIf" @click="startRigBox"></i>
        <i class="icon-right riBoxSw" v-show="!RigBoxIf" @click="startRigBox"></i>
        <editorOperation ref="editorOperation" :termHintList="termHintList"
                         :memoryHintList="memoryHintList" :isSeekBox="isSeekBox" :seekTxt="seekTxt"
                         :seekTxt2="seekTxt2" :seekNum="seekNum" :seekNum2="seekNum2"
                         :inputTxt="inputTxt" :queryData="queryData" :bCb="bCb" :row="row"
                         :targetInput="targetInput" :postilTarget="postilTarget"
                         :ifSubmit="isUpdatePostilBut" :updatePostilTxt="updatePostilTxt"
                         :postilId="postilId" @addTerm="addTerm" @onInputTxt="onInputTxt"
                         @onTargetInput="onTargetInput" @updateTableRow="updateTableRow"
                         @onSeekTxt="onSeekTxt" @onSeekTxt2="onSeekTxt2"
                         @onUpdatePostilTxt="onUpdatePostilTxt" @setIsSeekBox="setIsSeekBox"
                         @goQA="goQA" @seekChange="seekChange" @onReplace="onReplace"
                         @replaceChange="replaceChange" @previous="previous" @seekNext="seekNext"
                         @handleReplace="handleReplace" />
      </div>
    </div>

    <rightMenu :sentenceShow="sentenceShow" :ifSubmit="ifSubmit" :typeShow="typeShow"
               :isEditR="isEditR" :isLock="isLock" :format="(queryData.fileSuffix)" ref="rightMenu"
               v-show="rightMenuShow" @rigBoxShow="rigBoxShow" @rigAddTerm="rigAddTerm"
               @anewTranslate="anewTranslate" @mergeSentence="mergeSentence"
               @splitSentence="splitSentence" @unlockSentence="unlockSentence"
               @copySource="copySource" />
    <messageBox v-if="mesBox" :isShow="mesBox" :tit="tit" :txt="txt" :imgSrc="imgSrc" :cancel="true"
                confirmBut="保存并替换" callBut="保存至术语表" @message="empty" @messageIf="messageIf"
                @onCancel="onCancel" />
    <!-- 单词补全开始 -->
    <div id="WordBox" ref="WordBox" v-show="isWordBox">
      <ul>
        <li v-for="(item, index) in words" :key="index">
          {{ item }}
        </li>
      </ul>
    </div>
    <!-- 单词补全结束 -->
    <!-- 术语添加弹窗 -->
    <termDialog :dialogVisible="dialogVisible"></termDialog>
    <!-- 术语添加弹窗 -->

  </div>
</template>
<style lang="less">
@import "./assets/style.less";
</style>
<script>
// import Vue from "vue";
import editorHeader from "../../../editorTop/index.vue";
import { setTimeout } from "timers";
import messageBox from "@/common/messageBox.vue";
// import editorHeader from "./common/editorHeader.vue";
import editorTop from "./common/editorTop.vue";
import rightMenu from "./common/rightMenu.vue";
import mongolianLang from "./common/models/mongolianLang.vue";
import editorMixin from './common/mixin';
import seek from './common/seek.vue';
import editorOperation from './common/editorOperation.vue';
import termDialog from './common/termDialog.vue';
import { log } from 'util';
// import { setTimeout } from 'timers';
import { mapActions } from 'vuex';
import { setCursorEnd } from '@/services/common.js';
let rightClickElement;
export default {
  mixins: [editorMixin],
  data() {
    return {
      iframeSrc: "",
      targetList: [],
      sourceList: [],
      rightMenuShow: false,
      txtList: [], // 复制用的
      isTerm: false,
      isSearch: false,
      inputTxt: "",
      inputTxt2: "",
      timer: null,
      timer2: null,
      timeOut: null,
      scale_x: "1",
      scale_y: "1",
      targetInput: "",
      dictItemList: "", // 存储查词数据
      loading: true,
      userId: "",
      termHintList: [],
      memoryHintList: [],
      num: 1,
      imgSrc: require("@/assets/imgs/editor/qr_code_bg.png"), // 弹窗title背景图
      mesBox: false,
      tit: "添加术语",
      txt: "是否保存到项目术语库并替换所有未确认句段？",
      queryData: "",
      saveHint: "",
      wordText: "",
      placeholder: true,
      isWordBox: false,
      words: [],
      seekTxt: "",
      seekTxt2: "",
      project: false,
      cutOff: false,
      isSeekBox: false, // 1 = 查找/替换 2 = 查词 3 = 添加术语
      completion: "",
      contextRight: "",
      seekIndex: 0,
      seekNum: 0,
      seekNum2: 0,
      loadinginstace: "",
      mendSentId: "",
      cursor: "", // 光标
      RigBoxIf: true,
      isSplit: 1,
      backgroundImg: require("@/assets/imgs/editor/normal_lock.png"),
      ev: "",
      updateTime: null,
      progress: 0,
      taskTypeName: "",
      myZoom: 0.8,
      tableData: [],
      row: "",
      splitSourceSent: "",
      splitTargetSent: "",
      isSourceid: "",
      editorDe: "#cfe8cc", // 编辑器完成的样式
      bCb: false,
      editorid: 0,
      editorNo: "#454545",
      fileSuffix: "",
      seekOut: "",
      dragTimer: "",
      borderShow: false,
      fileShow: true,
      progressTime: null,
      pdfNum: 1,
      ifRepeatLock: "",
      ifOnlyPreview: false, // 全文不可编辑为1
      formLabelAlign: {
        hasComment: undefined,
        hasRepeatLock: undefined,
        transStatus: undefined,
      },
      isUpdatePostilBut: true,
      sourceLangDirection: "",
      targetLangDirection: "",
      isEngine: IS_ENGINE,
      engineTime: null,
      engineLoading: false,
      transResult: [],
      currentId: null,
      reviewVisible: false,
      popoverWidth: '500',
      supplierCode: null,
      state: true,
      popoverState: false,
    };
  },
  watch: {
    flag: function (val) {
      console.log(val);

    }
  },
  async created() {
    let that = this;
    that.fileSuffix = that.queryData.fileSuffix;
    if (that.fileSuffix == "ppt" || that.fileSuffix == "pptx") {
      that.getWord(that.queryData.fileSuffix);
    } else if (that.fileSuffix == "pdf") {
      that.fileShow = 2;
      that.getPdf(1, 1);
    } else {
      that.fileShow = false;
      this.$nextTick(() => {
        that.loadinginstace.close();
      })
    }
    await that.getTable(1, true);
  },

  components: {
    // editorHeader,
    editorTop,
    messageBox,
    rightMenu,
    editorOperation,
    termDialog,
    editorHeader,
    //蒙语显示的试图
    mongolianLang
  },
  mounted() {
    this.getprogress();
    this.$nextTick(() => {
      var that = this;
      // 通过$refs获取dom元素
      let mainBox = that.$refs.redactBox;
      let translationDom = document.getElementById('translation');
      let domScroll = document.getElementsByClassName('el-table__body-wrapper')[0];
      let tabDom = document.getElementById('tabBox');
      let shadeDom = document.getElementsByClassName('shade')[0];
      let thDom = document.getElementsByClassName("el-table__header-wrapper")[0];
      // 去掉系统右键
      this.editorClientHeight = document.documentElement.clientHeight - 118;
      let rightMenu = document.getElementById('rightMenu');
      tabDom.oncontextmenu = function () {
        window.event.returnValue = false;
        return false;
      };

      rightMenu.oncontextmenu = function () {
        window.event.returnValue = false;
        return false;
      };

      //语言判断 需要梳理
      if (((that.queryData.sourceLang) !== 'mno' && (that.queryData.targetLang) !== 'mno')) {
        domScroll.onscroll = function ($event) {
          that.viewBoxScroll($event);
        };
      }
      let topHeight = document.getElementsByClassName("topBox")[0].offsetHeight;

      // let headerHeight = document.getElementsByTagName("header")[0].offsetHeight;


      //语言判断 需要梳理
      if (((that.queryData.sourceLang) !== 'mno' && (that.queryData.targetLang) !== 'mno')) {
        thDom.onmousedown = function (e) {
          e = e || event;
          if (!that.fileShow) {
            return
          }
          shadeDom.style.zIndex = 30; // 增加蒙层权重
          let domHeight = tabDom.offsetHeight;
          let domTop = tabDom.offsetTop;
          let firstY = e.clientY;   //获取第一次点击的纵坐标
          let height = translationDom.offsetHeight;  //获取到元素的高度
          let Top = translationDom.offsetTop;   //获取到距离上边的距离
          document.onmousemove = function (e) {
            e = e || event;
            if (e.stopPropagation) e.stopPropagation();
            if (e.preventDefault) e.preventDefault();
            if (document.body.clientHeight / 2 < e.clientY) {  // 拖拽是要执行一次表格获取第二页
              let fun = function () {
                if (!that.timer2) {
                  if (that.cutOff) {
                    return;
                  }
                  that.num++;
                  that.cutOff = true;
                  that.getTable(that.num, false);
                  that.timer2 = null;
                }
                fun = function () {
                }
              };
              fun()
            }
            translationDom.style["height"] = height + (e.clientY - firstY) + "px";
            tabDom.style["height"] = domHeight - (e.clientY - firstY) + "px";
            tabDom.style["top"] = domTop + (e.clientY - firstY) + "px";

            if (e.clientY <= topHeight + headerHeight + 40) {
              translationDom.style["height"] = "40px";
              tabDom.style["height"] = mainBox.offsetHeight - translationDom.offsetHeight + "px";
              tabDom.style["top"] = translationDom.offsetHeight + "px";
              document.onmousemove = null;
              return
            }

            if (document.body.clientHeight - e.clientY <= 190) {
              translationDom.style["height"] = mainBox.offsetHeight - 200 + "px";
              tabDom.style["height"] = 200 + "px";
              tabDom.style["top"] = translationDom.offsetHeight + "px";
              document.onmousemove = null;
            }
          };
          document.onmouseup = function () {
            document.onmousemove = null;
            document.onmouseup = null;
            shadeDom.style.zIndex = 10;
          };
          return false;
        };
      }


      if (this.fileShow) {
        window.onresize = function () {
          tabDom.style.height = 200 + "px";
          translationDom.style.height = mainBox.offsetHeight - 200 + "px";
          tabDom.style.top = translationDom.offsetHeight + "px";
        }
      }
    })
  },

  beforeDestroy() {
    this.engineHide();
    this.$message.closeAll();
    this.loadinginstace.close(); // loading清除
    let domScroll = document.getElementsByClassName('el-table__body-wrapper')[0];
    if (domScroll && domScroll.onscroll) {
      domScroll.onscroll = null;
    }
  },

  computed: {
    getListIndex() {
      return function (row, index) {
        if ((this.tableData) && ((this.tableData.length) === index)) {
          return 'top-start'
        } else {
          return 'bottom-start'
        }
      };
    },
  },

  methods: {
    ...mapActions('editor', [
      'getCurrentRemarksInfo',
      'updateAddTemporaryTermList'
    ]),
    //点击替换方法
    handleReplace(data) {
      let row = this.row;
      console.log(row);

      const that = this;
      let divNode = document.getElementsByClassName("targetSentBox");
      let dom;
      for (let i of divNode) {
        if (i.getAttribute("sid") == row.id) {
          dom = i
        }
      }
      this.catReq1Service(
        "/api/v1/file/get_sent_machine_translation",
        {
          sid: row.id,
          companyCode: localStorage.myCompanyCode,
          taskType: this.queryData.taskType,
          fileId: that.queryData.fileId,
          taskId: this.queryData.taskId
        },
        "get"
      ).then(function (response) {
        if (!response.success) {
          return;
        }
        let { sourceSent, targetSent } = data[0];
        sourceSent = sourceSent.slice(sourceSent.indexOf(">") + 1, sourceSent.lastIndexOf("<"))
        that.tableData.forEach(item => {
          if (item.sourceSent === sourceSent) {
            item.targetSent = targetSent
          }
        })
        that.sentenceShow = false;
        row.targetSent = targetSent;
        that.$nextTick(() => {
          that.update(dom, row)
        })
      });
    },
    // 引擎替换
    repEngine(txt, id, supplierCode) {
      this.$set(this.engineRow, "targetSent", txt);
      this.$nextTick(() => {
        let divNode = document.getElementsByClassName("targetSentBox");
        let dom;
        for (let i of divNode) {
          if (i.getAttribute("sid") == this.engineRow.id) {
            dom = i
          }
        }
        dom.innerText = txt;
        this.supplierCode = supplierCode;
        this.update(dom, this.engineRow);
        this.$refs[`popover-${id}`].doClose();
      })
    },

    // 多引擎翻译
    async asyncTransFileSent(row) {
      const self = this;
      self.reviewVisible = true;
      const params = {
        srcLang: self.queryData.sourceLang,
        tgtLang: self.queryData.targetLang,
        transSent: [row.sourceSent]
      };
      self.currentId = (row.id);
      let popoverEle = document.getElementsByClassName("target-wrap")[0];
      if (!!popoverEle) {
        self.popoverWidth = (popoverEle.clientWidth) + 120;
      }
      // 获取引擎信息
      await self.getEngineInfo("/mtSupplierTrans/findAll", params, "post").then((resp) => {
        if (parseInt(resp.resultCode) === 1) {
          const result = resp.result;
          let length = (result.length);
          if (!!(result.length)) {
            result.map((items, index) => {
              let code = (items.code);
              self.engineResult(params, code, (row.id), (index + 1), length);
            });
          } else {
            self.engineLoading = false;
          }
        }
      });
    },

    //调用单独机翻接口---每次可能存在数据差别
    engineResult(param, code, id, index, length) {
      const self = this;
      const params = {
        ...param,
        "code": code
      };
      new Promise((resolve) => {
        self.getEngineResult("/mtSupplierTrans/single", params, "post").then(function (resp) {
          const result = (resp.result);
          if ((result.success)) {
            if ((self.currentId) === id) {
              resolve(result)
            }
          }
        })
      }).then((data) => {
        (self.transResult).push(data);
        self.$nextTick(() => {
          self.$refs[`popover-${self.currentId}`].updatePopper();
        });
      }).catch((err) => {
        return false
      }).finally(() => {
        self.engineLoading = false;
      });
    },

    engineHide() {
      console.log(this.engineTime);
      clearInterval(this.engineTime);
      this.engineTime = null
    },

    engineShow(row) {
      // this.isEngine &&
      let bool = (((row.contentEditable === 1) || this.repeatLock(row)));
      if (bool) {
        if (this.engineRow && this.engineRow.id !== row.id) {
          this.engineRow.visible = false;
        }
        this.transResult = [];
        this.engineLoading = true;
        this.asyncTransFileSent(row);
        this.engineRow = row;
      } else {
        this.$message({
          message: '改句子被锁定，无法进行调用引擎',
          type: 'warning'
        });
      }

    },

    // 跳到任务页码
    async toTaskIndex(data, list) {
      let sort;
      for (let index = 0; index < list.length; index++) {
        const element = list[index];
        if (element.userId == data.uid) {
          sort = element.startRow
        }
      }
      if (this.num >= sort) {
        let dom = this.$refs.redactBox.querySelector(
          `p[uid='${data.uid}']`
        ).parentNode.parentNode;

        dom.scrollIntoView()
      } else {
        let n = (sort - this.num) / 20;
        let f = Math.ceil(n);
        f.forEach(async (item) => {
          this.num++;
          await this.getTable(this.num);
        })
      }
    },

    // 取消译员任务段落高亮
    interpreterTaskOut() {
      this.interpreterTaskDomList.forEach(item => {
        item.classList.remove("interpreterTask")
      })
    },

    // 译员任务段落高亮
    interpreterTask(uid) {
      let divNode = document.getElementsByClassName("targetSentBox");
      this.interpreterTaskDomList = [];
      for (let i of divNode) {
        if (i.getAttribute("uid") == uid) {
          const dom = i.parentNode.parentNode;
          dom.classList.add("interpreterTask");
          this.interpreterTaskDomList.push(dom)
        }
      }
    },
    isflag() {
      this.loading = true
    },
    closeFlag() {
      this.loading = false
    },
    // 关闭编辑原文
    outSourceEditor() {
      this.isSourceEd = false;
      this.sourceEditorLefTag.style.border = "0px";
      this.isSourceid = "";
      this.sourceSid = "";
    },

    // 编辑原文
    sourceEditor() {
      if (!this.sourceSid) {
        this.$message.closeAll();
        this.$message({
          message: '光标在在原文区内时才能编辑原文哦~',
          type: "warning",
        });
        return
      }
      this.isSourceid = this.sourceSid;
      let dom;

      if (this.isSourceEd) {
        this.outSourceEditor();
        return
      }
      this.isSourceEd = true;
      let divNode = document.getElementsByClassName("sourceSentBox");
      for (let i of divNode) {
        if (i.getAttribute("sid") == this.isSourceid) {
          dom = i
        }
      }
      this.sourceEditorLefTag = dom;
      dom.style.border = "1px solid rgba(1,170,237,0.7)";
    },

    // 修改原文--原文失去焦点
    sourceBlur(e, row) {
      let relatedTarget = e.relatedTarget
      if (relatedTarget && ['revokeBtn', 'recoveryBtn'].includes(relatedTarget.id)) {
        setCursorEnd(e.target)
        return false
      }
      if (parseInt(this.isSourceid) === parseInt(row.id)) {
        this.tableData.forEach((item, index) => {
          if (parseInt(item.id) === parseInt(row.id)) {
            if (e.target.innerText.length < 1) {
              e.target.innerHTML = "&nbsp;";
            }
            let dom;
            let divNode = document.getElementsByClassName("sourceSentBox");
            for (let i of divNode) {
              if (parseInt(i.getAttribute("sid")) === parseInt(row.id)) {
                dom = i
              }
            }
            this.isSourceid = "";
            this.isSourceEd = false;
            dom.style.border = "0px";
            if (this.wordText !== e.target.innerText) {
              this.$set(this.tableData[index], 'sourceSent', e.target.innerText);
              this.$nextTick(() => {
                this.updateSource(e);
              })
            }
          }
        })
      }
    },

    //筛选
    changeFilter(data) {
      let that = this;
      console.log(data);
      for (let key in data) {
        if (data[key] == '') {
          data[key] = undefined
        }
      }
      this.tableData = [];
      this.formLabelAlign = data;
      this.num = 1;
      let domScroll = document.getElementsByClassName('el-table__body-wrapper')[0];
      if (!!domScroll && (domScroll.onscroll == null)) {

        domScroll.onscroll = function ($event) {
          that.viewBoxScroll($event);
        };
      }
      this.getTable(1)
    },

    async goQA(row) {
      let dom;
      let tabDom = document.getElementById('tabBox');
      this.tableData.forEach((item, index) => {
        if (item.id == row.id) {
          dom = tabDom.querySelectorAll(
            `p[sid='${row.id}']`
          )[1];
          dom.focus();
          dom.scrollIntoView();
          this.homologous(this.tableData[index])
        }
      });
      if (!dom) {
        this.QACurrent++;
        if (this.QACurrent >= 100) {
          return
        }
        this.num++;
        await this.getTable(this.num);
        this.goQA(row)
      }
    },

    // 复制原文到译文
    copySource() {
      let row = this.row;
      this.tableData.forEach((item, index) => {
        if (item == row) {
          this.$set(this.tableData[index], 'targetSent', this.tableData[index].sourceSent);
          let dom;
          let divNode = document.getElementsByClassName("sourceSentBox");
          for (let i of divNode) {
            if (i.getAttribute("sid") == row.id) {
              dom = i
            }
          }
          this.sentenceShow = false;
          this.update(dom, row)
        }
      })
    },

    // 修改批注
    updatePostil(row) {
      this.isSeekBox = 5;
      this.updatePostilTxt = item.comment;
    },

    // 更新批注
    updateTableRow(data) {
      this.tableData.forEach((item, index) => {
        if (item.id == data.sentId) {
          this.$set(this.tableData[index], "commentType", data.commentType);
          this.$set(this.tableData[index], "commentSent", data.commentSent);
          this.$set(this.tableData[index], "comment", data.comment);
          this.$set(this.tableData[index], "pid", data.id)
        }
      })
    },

    // 添加批注按钮
    async onAddPostil(row, index) {
      this.isUpdatePostilBut = (row.contentEditable || this.repeatLock(row));
      console.log(this.isSeekBox, 'this.isSeekBox');
      if ((row.id == this.postilTarget.sid && (this.isSeekBox == 5)) || this.isSeekBox == 4) {
        this.isSeekBox = false;
        return
      }
      if (!this.RigBoxIf) {
        this.startRigBox();
      }
      if ((!this.ifSubmit || !(row.contentEditable || this.repeatLock(row))) && index == 4) {
        return
      }
      const { fileId } = this.queryData
      const params = {
        transFileId: fileId,
        sentIdList: [row.id]
      }
      await this.getCurrentRemarksInfo(params)
      this.postilTarget = {
        txt: row.targetSent,
        sid: row.id,
        id: row.pid
      };
      // this.updatePostilTxt = row.comment;
      this.isSeekBox = index
    },

    // 判断重复句段是否锁定
    repeatLock(row) {
      return (!this.ifRepeatLock && (row.sameFileSentNo || row.sameProjectSentNo)) || (row.unlockStatus == 1 && row.contentEditable)
    },

    // 锁定句段的title
    statusTit(row) {
      if (!this.ifRepeatLock || row.unlockStatus == 1) {
        return ''
      }
      return row.sameFileSentNo > 0 ? "文件内重复句段锁定" : (row.sameProjectSentNo > 0 ? "项目内跨文件重复句段锁定" : "")
    },

    visionPattern(e) {
      if (e == "1") {
        this.bCb = false;
        sessionStorage.setItem("sessionBCb", this.bCb);
        this.editorNo = "#454545";
      } else if (e == "2") {
        this.bCb = true;
        sessionStorage.setItem("sessionBCb", this.bCb);
        this.editorNo = "#AAABAD";
      }
      // this.$nextTick(() => {
      //   var translation = document.getElementById("translation");
      //   var domList = translation.getElementsByClassName("tab1");
      //   // domList = Array.from(domList);
      //   // domList.forEach(item => {
      //     domList.style.color = this.editorNo;
      //     domList.style.background = "#AAABAD"
      //   // })
      // })
    },

    // 获取光标位置
    getCursortPosition(e, row) {
      this.row = row;
      rightClickElement = e;
      this.sentenceShow = !(e.target.className === "targetSentBox" || !e.target.isContentEditable);
      let pos = 0;
      pos = this.getDivPosition(e.target);
      this.splitSourceSent = e.target.innerText.slice(0, pos);
      this.splitTargetSent = e.target.innerText.slice(pos);
    },

    //可编辑获取坐标
    getDivPosition(element) {
      let caretOffset = 0;
      let doc = element.ownerDocument || element.document;
      let win = doc.defaultView || doc.parentWindow;
      let sel;
      if (typeof win.getSelection != "undefined") {
        //谷歌、火狐
        sel = win.getSelection();
        if (sel.rangeCount > 0) {
          //选中的区域
          let range = win.getSelection().getRangeAt(0);
          let preCaretRange = range.cloneRange(); //克隆一个选中区域
          preCaretRange.selectNodeContents(element); //设置选中区域的节点内容为当前节点
          preCaretRange.setEnd(range.endContainer, range.endOffset); //重置选中区域的结束位置
          caretOffset = preCaretRange.toString().length;
        }
      } else if ((sel = doc.selection) && sel.type != "Control") {
        //IE
        let textRange = sel.createRange();
        let preCaretTextRange = doc.body.createTextRange();
        preCaretTextRange.moveToElementText(element);
        preCaretTextRange.setEndPoint("EndToEnd", textRange);
        caretOffset = preCaretTextRange.text.length;
      }
      return caretOffset;
    },

    // 拆分句段
    splitSentence(e) {
      let that = this;
      let row = that.row;
      let i;
      that.tableData.forEach((item, index) => {
        if (item === row) {
          i = index;
        }
      });
      let params = {
        isNewVersion: 1,
        sentId: row.id,
        transFileId: this.queryData.fileId,
        transFileSentList: [{ sourceSent: this.splitSourceSent }, { sourceSent: this.splitTargetSent }]
      };

      this.catReq1Service(
        "/api/v1/sent/splitTransSent",
        params,
        "post"
      ).then(function (response) {
        if (!response.success) {
          return;
        }
        that.sentenceShow = false;
        let SourceSentData = response.result[0];
        let TargetSentData = response.result[1];
        // let oldSourceSentData = that.$refs.refTable.data[i];
        TargetSentData.contentEditable = 1;
        SourceSentData.contentEditable = 1;

        // console.log(that.$refs.refTable.tableData);
        // console.log(that.$refs.refTable.data);
        let tableData2 = (that.$refs.refTable.data) || (that.$refs.refTable.tableData);
        let data = Object.assign(tableData2[i], SourceSentData);
        tableData2.splice(i, 1, data);
        tableData2.splice(i + 1, 0, TargetSentData);
        that.$message.closeAll();
        that.$forceUpdate();
        // if (that.fileSuffix==="pdf") {
        //   let activeDom = document.getElementsByClassName("activeSty")[0];
        //   let parentDom = activeDom.parentNode;
        //   let strNode = document.createElement("span"); // 创建一个节点用来放拆分的上一部分
        //   let strTextNode = document.createTextNode(SourceSentData.sourceSent);
        //   strNode.appendChild(strTextNode);
        //   parentDom.insertBefore(strNode, activeDom)
        //   let sourceAttrs = activeDom.attributes;
        //   for (let i = sourceAttrs.length - 1; i >= 0; i--) { // 复制属性
        //     strNode.setAttribute(sourceAttrs[i].name, sourceAttrs[i].value);
        //   }
        //   strNode.setAttribute("sourceMd516", SourceSentData.sourceMd516);
        //   activeDom.setAttribute("sourceMd516", TargetSentData.sourceMd516);
        //   activeDom.setAttribute("sid", TargetSentData.id);
        //   activeDom.innerText = TargetSentData.sourceSent;
        //   activeDom.style.background = ""
        //   activeDom.style.background = this.bCb ? "#838eb4" : "#F3F70B";
        // }
        that.$message({
          message: "拆分成功!",
          type: "success"
        });

        let targetId = `target-${row.id}`;
        const tgtDom = document.getElementById(targetId);
        return new Promise((resolve) => {
          tgtDom.style.width = `100%`;
          resolve(true)
        }).then(() => {
          setTimeout(() => {
            tgtDom.style.width = '';
          }, 100)
        });

        // that.getTable(that.nuw)
      });
    },

    // 合并句段
    mergeSentence() {
      let that = this;
      let row = that.row;
      let targetSent;
      let i;
      that.tableData.forEach((item, index) => {
        if (item == row) {
          if (!that.tableData[index + 1]) {
            return
          }
          targetSent = that.tableData[index + 1];
          i = index + 1;
        }
      });
      // if (row.sectionIndex !== that.tableData[i].sectionIndex) {
      //   this.$message.closeAll();
      //   that.$message({
      //     message: "不支持跨段!",
      //     type: "warning"
      //   });
      //   return
      // }
      if (!targetSent) {
        return
      }
      this.catReq1Service(
        "/api/v1/sent/mergeTransSent",
        { sourceSentId: row.id, targetSentId: targetSent.id, transFileId: that.queryData.fileId },
        "post"
      ).then(function (response) {
        if (!response.success) {
          return;
        }
        // row.sourceSent = row.sourceSent + targetSent.sourceSent;
        // row.targetSent = row.targetSent + targetSent.targetSent;
        row.sourceSent = response.result.sourceSent;
        row.targetSent = response.result.targetSent;
        that.tableData.splice([i], 1);
        // that.$set(that.tableData,i+1,that.tableData[i+1])
        that.sentenceShow = false;
        // that.num--;
        that.$forceUpdate();
        that.$message.closeAll();
        // if (that.fileSuffix==="pdf") {
        //   let activeDom = document.getElementsByClassName("activeSty")[0];
        //   let targetTag = that.$refs.viewBox.querySelector(`span[sid='${targetSent.id}']`);
        //   activeDom.innerText = activeDom.innerText + targetTag.innerText;
        //   targetTag.innerText = ""
        // }
        that.$message({
          message: "合并成功!",
          type: "success",
        });
        let targetId = `target-${row.id}`;
        const tgtDom = document.getElementById(targetId);
        return new Promise((resolve) => {
          tgtDom.style.width = `100%`;
          resolve(true)
        }).then(() => {
          setTimeout(() => {
            tgtDom.style.width = '';
          }, 100)
        });

      })
    },

    unlockSentence() {
      let that = this;
      this.catReq1Service("/api/v1/file/updateSentUnlockStatus", {
        transFileId: this.queryData.fileId,
        sid: this.row.id
      }).then(function (response) {
        if (!response.success) {
          return;
        }
        that.$set(that.row, "unlockStatus", 1);
        that.$set(that.row, "contentEditable", 1)
      });
    },

    // 原文对照 样式 HTML
    html(row) {
      let active = document.getElementsByClassName("contrast")[0];
      if (active) {
        active.style.background = "";
        active.classList.remove("contrast");
      }


      let box = document.getElementsByClassName("translationBox")[0];
      let lefTag = this.$refs.redactBox.querySelector(
        `span[sid='${row.id}']`
      );
      if (!lefTag) {
        return
      }
      lefTag.scrollIntoView();
      lefTag.classList.add("contrast");
      lefTag.style.background = this.bCb ? "#838eb4" : "#F3F70B";
      console.log(lefTag, "active");
    },

    ppt(sectionIndex, slideName, iframeDom) {
      if (iframeDom.document.getElementById("slides0")) {
        slideName = "slides";
        // tagName = "text"
        sectionIndex = sectionIndex - 1;
      } else {
        slideName = "slideslideIface";
        // tagName = "tspan"
      }
      let sectionId = slideName + sectionIndex;
      return iframeDom.document.getElementById(sectionId);
    },

    pdf(sectionIndex, slideName, iframeDom) {
      if (iframeDom.document.getElementById("page_0")) {
        slideName = "page_";
        sectionIndex = sectionIndex - 1;
      }
      let sectionId = slideName + sectionIndex;
      console.log(sectionId, "sectionId");

      return iframeDom.document.getElementById(sectionId);
    },

    handleCurrentChange(val) {
      // this.currentRow = val;
    },

    tableRowClassName(row) {
      if (row && this.row.id == row.row.id && !this.bCb) {
        return "current-row"
      } else if (row && this.row.id == row.row.id && this.bCb) {
        return "current-row-night"
      } else {
        return ""
      }
    },

    getHint(e) {
      let acticeClass = e.target.getAttribute("sid");
      let tagList = tabBox.querySelectorAll(`p[sid='${acticeClass}']`);
    },

    // 原文对照 样式
    async homologous(row) {
      this.row = row;
      let acticeClass = row.id;
      let tagList = tabBox.querySelectorAll(
        `p[sid='${acticeClass}']`
      );
      let lefTag = tagList[0];
      this.getTerm(row.sourceSent);
      this.getmemory(row, 1);
      this.isSeekBox == 4 || this.isSeekBox == 5 ? this.isSeekBox = '' : '';
      if (!this.fileShow) {
        // this.html(row)
        return
      }
      let tagName, slideName, box;
      let sectionIndex = row.sectionIndex;
      let text = row.sourceSent;

      if (this.fileSuffix == "pdf") {  /// pdf格式
        let activeDom = document.getElementsByClassName("activeSty")[0];
        if (activeDom) {
          activeDom.style.background = "";
          activeDom.classList.remove("activeSty")
        }
        if (lefTag) {
          lefTag.style.background = this.bCb ? "#838eb4" : "#F3F70B";
          lefTag.classList.add("activeSty");
          lefTag.scrollIntoView()
        }
      } else {
        let iframeDom = document.getElementById("editorIframe").contentWindow;
        box = await this.ppt(sectionIndex, slideName, iframeDom);
        box.scrollIntoView() // 视图跳转
      }

      return;

      let dom = box.getElementsByTagName(tagName);
      console.log(dom, "dom");
      let domList = iframeDom.document.getElementsByClassName("contrast");
      let len = domList.length;
      domList = Array.from(domList);
      if (len > 0) {
        for (let i = len - 1; i > -1; i--) {
          if (i >= 0) {
            domList[i].style.background = "";
            domList[i].classList.remove("contrast");
            domList[i].style.outline = ""
          }
        }
      }
      dom = Array.from(dom);
      let domAry = [];
      let str = "";
      let ary = [];

      function nodeCirculation(params, text, index, len = 0) {
        let seekTxt = text.replace(/\s*/g, "");
        // debugger
        // console.log(params.textContent);
        if (!params || !params.textContent) {
          domAry = [];
          str = "";
          return
        }
        let textContent = params.textContent.replace(/\s*/g, "");
        if (seekTxt.indexOf(textContent) !== -1) {
          str = str + textContent;
          domAry.push(params);
          if (str == seekTxt) {
            console.log(domAry, "domAry");

            str = "";
            return
          }
          nodeCirculation(dom[index + 1], seekTxt, index + 1);
        } else {
          domAry = [];
          str = "";
          return
        }
      }

      dom.forEach((item, index) => {
        nodeCirculation(item, text, index, 0);
        domAry.length > 0 ? ary = domAry : null;
        domAry = [];
      });
      if (ary.length == 0) {
        return
      }
      ary.forEach(item => {
        item.style.outline = "rgb(255, 0, 0) solid 2px";
        item.classList.add("contrast")
      });
      ary[0].scrollIntoView() // 视图跳转
    },

    // 滑动
    async viewBoxScroll() {
      let self = this;
      this.rightMenuShow = false;
      let viewBox2 = document.getElementsByClassName('el-table__body-wrapper')[0];
      let viewBox3 = document.getElementsByClassName('is-scrolling-none')[0];

      let htmlHeight = viewBox2.clientHeight;
      let htmlHeight2 = viewBox3.clientHeight;
      if (this.engineRow) {
        this.engineRow.visible = false
      }
      if (viewBox3.scrollTop + htmlHeight2 + 50 > viewBox3.scrollHeight) {
        if (!self.timer2) {
          if (self.cutOff) {
            return;
          }
          self.timer2 = await setTimeout(function () {
            self.num++;
            self.cutOff = true;
            self.getTable(self.num);
            self.timer2 = null;
          }, 1000);
        }
      }
    },

    // 重新机翻句段
    anewTranslate() {
      let row = this.row;
      let that = this;
      let divNode = document.getElementsByClassName("targetSentBox");
      let dom;
      for (let i of divNode) {
        if (i.getAttribute("sid") == row.id) {
          dom = i
        }

      }

      if (!row.contentEditable) {
        this.$message.closeAll();
        this.$message({
          message: "不可编辑句段不支持重新机翻",
          type: "warning"
        });
        return;
      }
      this.catReq1Service(
        "/api/v1/file/get_sent_machine_translation",
        {
          sid: row.id,
          companyCode: localStorage.myCompanyCode,
          taskType: this.queryData.taskType,
          fileId: that.queryData.fileId,
          taskId: this.queryData.taskId
        },
        "get"
      ).then(function (response) {
        if (!response.success) {
          return;
        }
        // debugger
        that.sentenceShow = false;
        row.targetSent = response.result.convertStr;
        that.$nextTick(() => {
          let data = (that.$refs.refTable.data) || (that.$refs.refTable.tableData);
          data.forEach(item => {
            if (item == row) {
              dom.innerText = response.result.convertStr;
              item.targetSent = response.result.convertStr
            }
          });

          that.update(dom, row)
        })
      });
    },

    // 缩小
    sizeNarrow() {
      if (this.myZoom < 0.3) {
        return;
      }
      this.myZoom = this.myZoom - 0.2;
      this.$nextTick(() => {
        const editorIframe = document.getElementById("editorIframe");
        if (!editorIframe) {
          return
        }
        let iframeBody = editorIframe.contentWindow.document.body;
        console.log(iframeBody);
        iframeBody.style.zoom = this.myZoom
      });
    },

    // 放大
    sizeEnlarge() {
      if (this.myZoom > 1.1) {
        return;
      }
      this.myZoom = this.myZoom + 0.2;
      this.$nextTick(() => {
        const editorIframe = document.getElementById("editorIframe");
        if (!editorIframe) {
          return
        }
        let iframeBody = editorIframe.contentWindow.document.body;
        console.log(iframeBody)
        iframeBody.style.zoom = this.myZoom
      });
    },

    //  右侧菜单开关
    startRigBox() {
      if (!this.RigBoxIf) {
        this.RigBoxIf = true;
        this.RigSwitchVal = "true";
        this.$nextTick(() => {
          this.$refs.redactBox.style.width = "calc(100% - 360px)";
          this.$refs.rigContantBox.style.width = "300px";
          this.$refs.rigContantBox.style.marginRight = "20px";
        });
      } else {
        this.RigBoxIf = false;
        this.RigSwitchVal = "false";
        this.$nextTick(() => {
          this.$refs.redactBox.style.width = "calc(100% - 40px)";
          this.$refs.rigContantBox.style.width = "0px";
          this.$refs.rigContantBox.style.marginRight = "0";
        });
      }
    },

    // 开启编辑器
    codeRigBox() {
      this.RigBoxIf = true;
      this.RigSwitchVal = "true";
      this.$nextTick(() => {
        this.$refs.redactBox.style.width = "calc(100% - 360px)";
        this.$refs.rigContantBox.style.width = "300px";
        this.$refs.rigContantBox.style.marginRight = "20px";
      });
    },

    seekShow() {
      var that = this;
      that.codeRigBox();
      if (that.isSeekBox == 1) {
        that.isSeekBox = false;
        let dom = document.getElementById("tab1");
        let seekActive = dom.getElementsByClassName("seekActive");
        let len = seekActive.length;
        if (len > 0) {
          for (let i = len - 1; i > -1; i--) {
            if (i >= 0) {
              seekActive[i].style.background = "";
              seekActive[i].classList.remove("seekActive");
            }
          }
        }
        that.seekTxt = "";
      } else {
        that.isSeekBox = 1;
        // that.seekChange();
      }
    },

    // 查找 下一个
    seekNext() {
      let domList = document.getElementsByClassName("seekActive");
      if (domList.length == 0 || domList.length == 1) {
        return;
      }
      if (this.seekIndex >= domList.length - 1) {
        domList[0].style.background = "rgb(163, 217, 241)";
        domList[this.seekIndex].style.background = "yellow";
        this.seekIndex = 0;
        domList[this.seekIndex].scrollIntoView();
        this.seekNum = 1;
        return;
      }

      this.seekIndex++;
      this.seekNum++;
      // console.log(this.seekIndex);
      domList[this.seekIndex].scrollIntoView();
      // let top = this.$refs.viewBox2.scrollTop;
      // this.$refs.viewBox2.scrollTo(0, num);
      if (this.seekIndex > 0) {
        domList[this.seekIndex].style.background = "rgb(163, 217, 241)";
        domList[this.seekIndex - 1].style.background = "yellow";
      } else {
        domList[this.seekIndex].style.background = "rgb(163, 217, 241)";
      }
    },

    // 查找 上一个
    previous() {
      let domList = document.getElementsByClassName("seekActive");
      let len = domList.length;
      if (len == 0 || len == 1) {
        return;
      }

      if (this.seekIndex == 0) {
        domList[len - 1].style.background = "rgb(163, 217, 241)";
        domList[0].style.background = "yellow";
        this.seekIndex = len - 1;
        domList[this.seekIndex].scrollIntoView();
        this.seekNum = len;
        return;
      }
      this.seekIndex--;
      this.seekNum--;
      domList[this.seekIndex].scrollIntoView();
      domList[this.seekIndex].style.background = "rgb(163, 217, 241)";
      domList[this.seekIndex + 1].style.background = "yellow";
    },

    // 查找
    seekChange() {
      let domList = document.getElementsByClassName("seekActive");
      let len = domList.length;
      if (len > 0) {
        for (let i = len - 1; i > -1; i--) {
          if (i >= 0) {
            domList[i].style.background = "";
            domList[i].classList.remove("seekActive");
          }
        }
      }
      this.seekNum2 = 0;
      this.seekNum = 0;
      this.seekIndex = 0;
      if (this.seekTxt == "") {
        return;
      }
      let oAt = document.getElementById('tab1');
      let dom = oAt.getElementsByTagName("p");
      let seekTxt = this.seekTxt;
      if (seekTxt.indexOf(".") != -1 || seekTxt.indexOf("?") != -1) {
        let ary = seekTxt.split("");
        for (let i = 0; i < ary.length; i++) {
          if (ary[i] == "." || ary[i] == "?") {
            ary[i] = "\\" + ary[i]
          }
        }
        seekTxt = ary.join("")
      }

      let reg = new RegExp(seekTxt, "ig");
      dom = Array.from(dom);
      dom.forEach((item, index) => {
        let result = reg.exec(item.innerText);
        if (result) {
          let activeStr = item.innerText.replace(reg, function (params) {
            // console.log(params);
            return (
              '<span class="seekActive" style="background:yellow;">' +
              params +
              "</span>"
            );
          });
          item.innerHTML = activeStr;
          this.$nextTick(() => {
            let domActList = document.getElementsByClassName("seekActive");
            this.seekNum2 = domActList.length;
            this.seekNum = 1;
            domActList[0].scrollIntoView();
            domActList[0].style.background = "rgb(163, 217, 241)";
          });
        }
      });
    },

    // 替换
    onReplace() {
      if (!this.ifSubmit) {
        // 提交任务不可以替换
        this.$message.closeAll();
        this.$message({
          message: "不可修改",
          type: "warning"
        });
        return;
      }
      let domList = document.getElementsByClassName("seekActive");
      if (domList.length < 1) {
        // 为空时不执行
        return;
      }
      let dom = domList[this.seekIndex].parentNode;
      if (dom.getAttribute("type") === "source" || !dom.isContentEditable) {
        // 只可编辑替换
        return;
      }
      let sonDom = domList[this.seekIndex];
      sonDom.style.background = "";
      sonDom.innerText = this.seekTxt2;
      sonDom.classList.remove("seekActive");
      let row;
      this.tableData.forEach((item) => {
        if (item.id == dom.getAttribute("sId")) {
          row = item
        }
      });
      // this.changeText(dom, row);
      //替换
      this.update(dom, row);


      this.$nextTick(() => {
        this.seekNum2 = domList.length;
        if (this.seekNum > this.seekNum2) {
          this.seekNum = this.seekNum2;
          this.seekIndex--;
          domList[this.seekIndex].style.background = "rgb(163, 217, 241)";
        } else {
          this.seekIndex ? domList[this.seekIndex].style.background = "rgb(163, 217, 241)" : '';
        }
      });
      if (this.seekNum2 == 1) {
        this.seekNum = 0;
      }
    },

    // 全部替换
    async replaceChange() {
      let that = this;
      if (!this.ifSubmit) {
        // 提交任务不可以替换
        this.$message.closeAll();
        this.$message({
          message: "不可修改",
          type: "warning"
        });
        return;
      }
      var str2 = this.seekTxt;
      var str3 = this.seekTxt2;
      var oAt = document.getElementById('tab1');
      let str1 = this.$refs.viewBox2.innerHTML;
      if (!str2) {
        // this.$message.closeAll();
        // this.$message({
        //   message: "请输入要替换的内容",
        //   type: "warning"
        // });
        return;
      }
      let dom = oAt.getElementsByTagName("p");
      dom = Array.from(dom);
      let seekTxt = this.seekTxt;
      if (seekTxt.indexOf(".") != -1 || seekTxt.indexOf("?") != -1) {
        let ary = seekTxt.split("");
        for (let i = 0; i < ary.length; i++) {
          if (ary[i] == "." || ary[i] == "?") {
            ary[i] = "\\" + ary[i]
          }
        }
        seekTxt = ary.join("")
      }
      let reg = new RegExp(seekTxt, "ig");
      dom.forEach(item => {
        if (
          item.isContentEditable && item.getAttribute("type") == "target"
        ) {
          let text = item.innerHTML;
          let result = reg.exec(item.innerText);
          if (result) {
            if (str3 == "" && item.innerText == "") {
              // 阻止修改为空
              return;
            }
            let activeStr = item.innerText.replace(reg, function (params) {
              return (
                '<span class="seekActive" style="background:yellow;">' +
                str3 +
                "</span>"
              );
            });
            that.seekIndex = 0;
            item.innerHTML = activeStr;
            if (item.innerText == "") {
              item.innerHTML = text;
              this.$message.closeAll();
              this.$message({
                message: "对应的译文不能为空",
                type: "warning"
              });
            }
          }
        }
      });
      await this.$nextTick(() => {
        let seekDom = document.getElementsByClassName("seekActive");
        seekDom = Array.from(seekDom);
        for (let i = 0; i < seekDom.length; i++) {
          if (seekDom[i].parentNode.isContentEditable && seekDom[i].parentNode.getAttribute("type") == "target") {
            let row = this.tableData.filter(item => item.id == seekDom[i].parentNode.getAttribute("sId"))
            // this.changeText(seekDom[i].parentNode, row[0]);
            this.update(seekDom[i].parentNode, row[0])
          }
        }
        that.seekChange();
      });
    },

    // 提交任务
    submit() {
      let self = this;
      self.loadinginstace = self.$loading({ fullscreen: true });
      self.catReq1Service("/api/v1/fileTask/finishTask", {
        id: self.queryData.fileId,
        taskType: self.queryData.taskType,
        taskId: self.queryData.taskId
      }).then(function (response) {
        if (!response.success) {
          self.loadinginstace.close(); // loading清除
          return;
        }
        if (parseInt(response.resultCode) === 1) {
          self.ifOnlyPreview = false;
          self.$message.closeAll();
          self.$message({
            message: "提交任务成功",
            type: "success"
          });
          self.isSeekBox == 5 || self.isSeekBox == 4 ? self.isSeekBox = '' : '';
          self.getprogress();
          setTimeout(() => {
            self.tableData.forEach(item => {
              item.contentEditable = 0
            });
            self.loadinginstace.close(); // loading清除
          }, 10);
          self.checkTaskStatus();
          self.$forceUpdate();
        }
      });
    },

    reTranslation() {
      let that = this;
      setTimeout(() => {
        that.tableData.forEach(item => {
          item.contentEditable = 0
        });
        that.loadinginstace.close(); // loading清除
      }, 10);
    },

    rigBoxShow(data) {
      this.codeRigBox();
      switch (data) {
        case 2:
          this.isSeekBox == 2 ? this.isSeekBox = false : this.isSeekBox = 2;
          this.search();
          break;
        case 3:
          this.isSeekBox == 3 ? this.isSeekBox = false : this.isSeekBox = 3;
          break;
        case 6:
          this.isSeekBox == 6 ? this.isSeekBox = false : this.isSeekBox = 6;
          break;
        case '2_1':
          this.isSeekBox = 2;
          this.search();
          break;
        default:
          break;
      }
      let dom = document.getElementById("tab1");
      let seekActive = dom.getElementsByClassName("seekActive");
      let len = seekActive.length;
      if (len > 0) {
        for (let i = len - 1; i > -1; i--) {
          if (i >= 0) {
            seekActive[i].style.background = "";
            seekActive[i].classList.remove("seekActive");
          }
        }
      }
      this.seekTxt = "";
    },

    // 自定义右键菜单
    oncontextmenu(row, e) {
      this.row = row;
      rightClickElement = e;
      e = e || window.event;
      // this.isFunBut(e);
      window.event.returnValue = false;
      let rm = this.$refs.rightMenu.$el;
      this.rightMenuShow = true;
      //2.设置菜单的位置等于鼠标的坐标
      //判断：如果鼠标的位置+菜单的宽度>网页的宽度，那么就改为右边定位
      //鼠标坐标
      let doc = event.target.ownerDocument || event.target.document;
      let win = doc.defaultView || doc.parentWindow;
      let pos = this.getSelectionCoords(win, 'p');
      let mx = pos.x + 10;
      let my = pos.y + 10;
      // let mx = e.clientX;
      // let my = e.clientY;
      //菜单宽度
      this.$nextTick(() => {
        let rmWidth = parseInt(rm.clientWidth);
        let rmHeight = parseInt(rm.clientHeight);
        //网页的宽度(高度用同样的方法解决)
        let pageWidth = document.documentElement.clientWidth;
        let pageHeight = document.documentElement.clientHeight;
        //console.log(pageWidth);
        if (mx + rmWidth < pageWidth) {
          rm.style.left = mx + 10 + "px";
        } else {
          rm.style.left = mx - rmWidth - 10 + "px";
        }
        if (my + rmHeight < pageHeight) {
          rm.style.top = my + 10 + "px";
        } else {
          rm.style.top = my - rmHeight - 10 + "px";
        }
        //3.显示右键菜单
        setTimeout(() => {
          this.rightMenuShow = true;
        }, 10);
        //阻止默认的右键菜单显示
        return false;
      });
      //增加解锁标记
      this.isLock = !!(this.ifRepeatLock && row.unlockStatus !== 1 && (row.sameProjectSentNo > 0 || row.sameFileSentNo > 0));
    },

    // 选中
    pitchOn(e, row, type) {
      let event = e || window.event;
      let target = event.srcElement ? event.srcElement : event.target;
      if (
        /input|textarea/i.test(target.tagName) &&
        /firefox/i.test(navigator.userAgent)
      ) {
        //Firefox在文本框内选择文字
        let staIndex = target.selectionStart;
        let endIndex = target.selectionEnd;
        if (staIndex !== endIndex) {
          let sText = target.value.substring(staIndex, endIndex);
          this.tanchu(sText, target, event, row, type);
        }
      } else {
        //获取选中文字
        let sText =
          document.selection == undefined
            ? document.getSelection().toString()
            : document.selection.createRange().text;
        if (sText !== "") {
          //将参数传入回调函数fn
          this.tanchu(sText, target, event, row, type);
        }
      }
    },

    // 选中文字
    tanchu(txt, tar, event, row, type) {
      if (type) {
        this.targetInput = txt;
      } else {
        this.inputTxt = txt;
      }
      this.seekTxt = txt;
      // this.oncontextmenu(row, event);
      if (this.isSeekBox == 1) {
        this.seekChange();
      }
      this.txtList.push(txt);
      if (this.txtList.length > 4) {
        this.txtList.shift();
      }
    },

    // 获取文档表格
    async getTable(data = 1, isTop) {
      let marker;
      let that = this;
      that.loading = true;
      console.log("loading 清除")
      let params = {
        row: 50,
        startSort: data,
        taskId: this.queryData.taskId,
        taskType: that.queryData.taskType,
        marker: that.queryData.transStatus,
        transFileId: this.queryData.fileId,
        comparedHighlight: this.isRecord ? 1 : 0,
        hasComment: this.formLabelAlign.hasComment,
        transStatus: this.formLabelAlign.transStatus,
        hasRepeatLock: this.formLabelAlign.hasRepeatLock,
      };
      this.startSort = data;
      console.log(that.queryData)
      if (that.queryData.transStatus === 2) {
        // 项目
        marker = 2;
      } else {
        // 任务
        marker = 1;
      }
      if (that.isScroll) { // isScroll自動加載後300毫秒不可以觸發滾動
        return
      }
      if (data === 1) {
        await that.queryBySentId();
      }
      await this.catReq1Service("/api/v1/file/loadEditSentPairFileByPage", params).then(async function (response) {
        if (!response.success) {
          console.log("--------")
          that.loading = false; // loading清除
          return;
        }
        let list = response.result.transSentRespVoList;
        let resultLen = ((list.length) === 50);
        let ifOnlyPreview = response.result.ifOnlyPreview;
        if (!resultLen) {
          if (isTop) {
            setTimeout(async () => {
              let dom = that.$refs.redactBox.querySelector(`p[uid='${that.queryData.userId}']`);
              if (dom) {
                await dom.scrollIntoView();
                that.isScroll = true;
                setTimeout(() => {
                  that.isScroll = false;
                }, 2000);
              }
            }, 500)
          }
        }

        if (!list.length) {
          that.loading = false;
          return
        }
        // 项目下不可编辑则不能添加术语
        if (marker === 2) {
          that.ifOnlyPreview = !ifOnlyPreview;
        } else {
          // 任务下不可编辑则不能添加术语，可编辑：在翻译状态下可以添加，审校等不可
          that.ifOnlyPreview = ifOnlyPreview ? !ifOnlyPreview : (that.queryData.taskType < 2 ? !ifOnlyPreview : false);
        }
        that.ifRepeatLock = response.result.ifRepeatLock;
        let domScroll = document.getElementsByClassName('el-table__body-wrapper')[0];
        if (list.length < 1) {
          domScroll.onscroll = null; // PDF预览滚到条
          that.loading = false; // loading清除
          return
        }
        list.forEach(item => {
          item.commentType = 0;
          item.commentSent = "";
          item.comment = "";
          item.pid = "";
          item.visible = false;
          if ((item.sameFileSentNo || item.sameProjectSentNo) && that.ifRepeatLock) {
            item.contentEditable = 0
          }
        });

        console.log(that.postilList, 'that.postilList');
        if (that.postilList.length > 0) {
          that.postilList.forEach(item => {
            list.forEach(i => {
              if (item.sentId == i.id && item.commentType == 3) {
                i.commentType = item.commentType;
                i.commentSent = item.commentSent;
                i.comment = item.comment;
                i.pid = item.id;
              }
            })
          })
        }
        that.num = that.num + 49;
        that.cutOff = false;
        that.tableData = [...that.tableData, ...list];
        // that.$nextTick(() => {
        //   if (marker) {
        //     let newNum = ++that.num;
        //     that.getTable(newNum, true);
        //   }
        // });
        // 避免加载一段未出现滚动条
        //语言判断 需要梳理
        if (((that.queryData.sourceLang) !== 'mno' && (that.queryData.targetLang) !== 'mno')) {
          let top = 5;
          if (that.hasScrollbar(domScroll)) {
            top = domScroll.scrollTop;
          }
          if (!that.hasScrollbar(domScroll)) {
            // that.num++;
            // that.getTable(that.num, true);
          }
        }
      }).finally(() => {
        console.log(1)
        that.loading = false;
      });
    },

    // 获取文档
    getPdf(data, type) {
      // type=1 滚动条向下 type=2 滚动条向上 一页展示10个页码
      var that = this;
      let marker;
      let taskType = that.queryData.taskType;
      if (that.queryData.transStatus == 2) {
        // 区分进入口 项目&任务
        marker = 2; // 项目
      } else {
        marker = 1;
      }
      this.catReq1Service(
        `/api/v1/file/load_edit_file`,
        {
          // uid: that.uid,
          fileId: that.queryData.fileId,
          partIndex: data,
          marker,
          taskType: taskType,
          taskId: this.queryData.taskId
        },
        "get"
      ).then(function (response) {
        if (!response.success) {
          return;
        }
        that.sourceList.push(response.result.convertStr);
        that.loadinginstace.close();
        if (
          response.result.convertStr
        ) {
          that.pdfNum++;
          that.getPdf(that.pdfNum, 1);
        }
      });
    },

    // 获取文档
    getWord(fileSuffix) {
      let that = this;
      let url = "/api/v1/file/getFileHtmlOssUrl";
      fileSuffix == "html" ? url = "/api/v1/file/getHtmlConvert" : null;
      this.catReq1Service(
        url,
        {
          id: that.queryData.fileId
        },
        "post"
      ).then(function (response) {
        if (!response.success) {
          return;
        }
        if (!that.fileShow) {
          that.loadinginstace.close(); // loading清除
        } else {
          that.iframeSrc = response.result.ossUrl;
          let iframe = document.getElementById("editorIframe");
          if (iframe.attachEvent) {
            iframe.attachEvent("onload", function () {
              that.setIframe()
            });
          } else {
            iframe.onload = function () {
              that.setIframe()
            };
          }
        }
      });
    },

    setIframe() {
      let iframeWin = document.getElementById("editorIframe").contentWindow;
      let svgDom = iframeWin.document.getElementsByTagName("svg");
      if (svgDom.length < 1) {
        this.loadinginstace.close(); // loading清除
        return
      }
      svgDom = Array.from(svgDom);
      for (let i = 0; i < svgDom.length; i++) {  // 使svg居中
        svgDom[i].style.position = "relative";
        svgDom[i].style.left = "50%";
        svgDom[i].style.transform = "translateX(-50%)";
      }
      let iframeBody = iframeWin.document.body;
      iframeBody.style.zoom = this.myZoom;
      this.loadinginstace.close(); // loading清除
    },

    // 添加术语
    async addTermSent(isReplace) {
      // let that = this;
      // isReplace ? that.dialogVisible = true : null;
      // let params = {
      //   fileId: that.queryData.fileId,
      //   sourceSent: that.inputTxt,
      //   targetSent: that.targetInput,
      //   isReplace,
      //   isTermHighlight: true,
      // };
      const { fileId, taskId } = this.queryData
      const params = {
        fileId,
        isReplace,
        isTermHighlight: true,
        sourceSent: this.inputTxt,
        targetSent: this.targetInput,
        taskId,
      }
      const { success, result } = await this.updateAddTemporaryTermList(params)
      if (!success) {
        return false
      }
      this.$message.closeAll()
      this.$message.success('添加成功')
      result.forEach(replaceItem => {
        this.tableData.forEach((item, index) => {
          if (Number(replaceItem.id) === Number(item.id)) {
            item.targetSent = replaceItem.targetSent
            this.$set(this.tableData[index], 'targetSent', replaceItem.targetSent)
          }
        })
      })
      // this.catReq1Service("/api/v1/termSent/addTermSent", params).then(function (
      //   response
      // ) {
      //   that.dialogVisible = false;
      //   if (!response.success) {
      //     return;
      //   }
      //   let data = response.result;
      //   data.forEach((item) => {
      //     that.tableData.forEach((key, i) => {
      //       if (parseInt(item.id) === parseInt(key.id)) {
      //         key.targetSent = item.targetSent;
      //         that.$set(that.tableData[i], "targetSent", item.targetSent)
      //       }
      //     })
      //   });
      //   that.$message({
      //     message: isReplace ? "已替换所有未确认句段中的术语" : "术语已经添加到项目术语库",
      //     type: "success"
      //   });
      //   that.inputTxt = "";
      //   that.targetInput = "";
      // });
    },

    setTermSent(data) {
      data.forEach((item, index) => {
        this.tableData.forEach((key, i) => {
          if (item.id == key.id) {
            key.targetSent = item.targetSent;
            this.$set(that.tableData[i], "targetSent", item.targetSent)
          }
        })
      })
    },

    //  单词补全
    AutoComple(event, row) {
      this.changeText(event.target, row);
      if (this.queryData.targetLang !== "en") {
        return;
      }
      let wordDom = document.getElementById("tab1");
      if (!row) {
        return;
      }
      if (event.data == null || event.data === " ") {
        return;
      }
      this.AutoCompleMixin(wordDom, row.sourceSent, 'p')
    },

    // 回车确认
    enterKey(e = rightClickElement, row) {
      let k = e.keyCode || e.which;
      let sid;
      if (k === 13) {
        e.returnValue = false;
        let domList = document.querySelectorAll(`p[contenteditable='${this.contentEditableValue}']`);
        domList = Array.from(domList).filter((item) => item.getAttribute("type") === "target");
        let isCommitVersion = 1
        this.update(e.target, row, isCommitVersion);
        domList.forEach((item, index) => {
          if (item.getAttribute("sId") == row.id) {
            if (index + 1 !== (domList.length)) {
              domList[index + 1].focus();
              sid = domList[index + 1].getAttribute("sId")
            }
          }
        });
        this.tableData.forEach((item, index) => {
          if (item.id == (sid || row.id)) {
            this.homologous(this.tableData[index])
          }
        })
      } else {
        let acticeClass = e.target.getAttribute("sid");
        let tagList = tabBox.querySelectorAll(
          `p[sid='${acticeClass}']`
        );
      }
    },

    // 聚焦事件
    onFocus(e, row) {
      this.isFunBut(e);
      this.interpreteruid = row.transUserId;
      this.wordText = e.target.innerText; // 用于修改
      if (e.target.getAttribute("type") === 'target') {
        this.writingSpeed();
        const sid = e.target.getAttribute("sid");
        let lefTag = tabBox.querySelector(`p[sid='${sid}']`);
        this.lefTagText = lefTag.innerText;
      }
    },

    //失去焦点保存
    blurText(event, row) {
      const dom = event.target
      let relatedTarget = event.relatedTarget
      if (relatedTarget && ['revokeBtn', 'recoveryBtn'].includes(relatedTarget.id)) {
        setCursorEnd(dom)
        return false
      }
      const sid = dom.getAttribute("sid");
      let lefTag = tabBox.querySelector(`p[sid='${sid}']`);

      // console.log(dom.innerText);
      // console.log(self.wordText);
      if ((dom.innerText) === (this.wordText)) {
        return true
      }
      if (this.contrastStatus) {
        lefTag.innerText = this.lefTagText;
        this.contrastStatus = false;
      }
      Reflect.set(event, 'innerText', (dom.innerText));
      this.update(dom, row);
    },

    sourceChangeText(e, row) {
      if (this.isSourceid != row.id) {
        e.target.innerText = row.sourceSent
      }
    },

    // 修改接口
    update(event, row, isCommitVersion = 0, timeOut = 0) {
      // console.log(event);
      // console.log(row);
      // console.log(row.id);
      if ((this.queryData.sourceLang) === 'mno' || (this.queryData.targetLang) === 'mno') {
        let targetId = event.getAttribute('id');
        const tgtDom = document.getElementById(targetId);
        tgtDom.style.width = '100%';
        setTimeout(() => {
          tgtDom.style.width = '';
        }, 500)
      }

      let that = this;
      let taskType = this.queryData.taskType;
      let innerText = (event.innerText);
      that.saveHint = "正在自动保存...";
      that.state = false;
      if (event.innerText == "") {
        event.innerText = "&nbsp;";
        row.targetSent = " "
      } else if (event.innerText == "/n") {
        event.innerText = "&nbsp;";
        row.targetSent = " "
      }
      let costTime = this.oldTime ? (new Date() - this.oldTime - timeOut) / 1000 : undefined;
      if (costTime <= 1) {
        costTime = 1;
      } else {
        Math.round(costTime)
      }
      let params = {
        isSaveVersion: 1,
        isCommitVersion,
        isNewVersion: 1,
        sentId: row.id,
        fileId: that.queryData.fileId,
        content: event.innerText,
        companyCode: localStorage.myCompanyCode,
        taskType: taskType,
        status: row.status,
        taskId: this.queryData.taskId,
        costTime
      };

      new Promise((resolve) => {
        this.catReq1Service("/api/v1/file/updateFileSent", params).then(function (response) {
          if (!response.success) {
            return;
          }
          that.writingSpeed();
          that.saveHint = "保存成功！";
          setTimeout(() => {
            that.saveHint = "";
          }, 500);
          clearTimeout(that.progressTime);
          that.progressTime = window.setTimeout(() => {
            that.getprogress();
          }, 10000);
        }).catch(function (error) {
          that.saveHint = "保存失败！";
          setTimeout(() => {
            that.saveHint = "";
          }, 500);
        }).finally(() => {
          that.state = true
        });
        resolve(true)
      }).then((data) => {
        let numberParams = {
          supplierCode: (that.supplierCode),
          sourceLang: (that.queryData.sourceLang),
          targetLang: (that.queryData.targetLang),
        };
        console.log('更新次数--调用统计--统计量+1');
        console.log(numberParams);
        //&& (that.isEngine)
        if (Reflect.has(numberParams, 'supplierCode') && !!(numberParams.supplierCode) && (that.isEngine)) {
          that.addStatisticAjax('/api/v1/mtSupplierCount/updateCallNum', numberParams, 'post');
        }

        if (parseInt(taskType) === 1) {
          row.status = 2 // 成功把状态改为2_翻译
        } else if (parseInt(taskType) === 2) {
          row.status = 4 // 成功把状态改为4_审校
        } else {
          row.status = 5 // 成功把状态改为5_复审
        }
        that.tableData.forEach((item, index) => {
          if (item.sourceMd516 === row.sourceMd516) {
            item.targetSent = innerText;
            that.$set(that.tableData[index], "targetSent", event.innerText)
          }
        });
      })
    },
    getprogress() {
      let urlInfo = this.$store.getters['editor/getUrlInfo'];
      if (urlInfo.type === "task" || urlInfo.type === "school") {
        let data = Object();
        Reflect.set(data, 'id', (urlInfo.fileId));
        Reflect.set(data, 'fileId', (urlInfo.fileId));
        Reflect.set(data, 'taskId', (urlInfo.taskId));
        Reflect.set(data, 'taskType', (urlInfo.taskType));
        this.$store.dispatch('editor/getTaskProgress', data);
      } else {
        this.$store.dispatch("editor/getFileInfo", { id: urlInfo.fileId })
      }
    },
    // 修改
    changeText(event, row, index) {
    },

    changeIsSplit(val) {
      this.isSplit = val
    }

  }
};
</script>
<style lang="less" scoped>
.backColorB {
  background: rgba(33, 44, 50, 1) !important;

  #bagBox {
    background: rgba(33, 44, 50, 1) !important;
  }

  #sourceText {
    background: rgba(48, 51, 60, 1) !important;

    div {
      p {
        span {
          color: red !important;
        }
      }
    }
  }

  #translation {
    background: rgba(48, 51, 60, 1) !important;
    color: #c6c6c6 !important;
  }

  .progressBox {
    color: white !important;
  }

  /deep/ .el-progress-bar__outer {
    background-color: #4d515f !important;
  }

  /deep/ .el-progress-bar__inner {
    background: #507383 !important;
  }

  /*下拉框颜色*/

  /deep/ .el-popper {
    /deep/ .el-scrollbar {
      /deep/ .el-scrollbar__view {
        /deep/ .el-select-dropdown__item {
          background: #507383 !important;
        }

        background: #507383 !important;
      }
    }
  }

  .operationBox {
    background: rgba(48, 51, 60, 1) !important;
    color: #c6c6c6 !important;

    h3 {
      background: #507383 !important;
    }

    h4 {
      color: #c6c6c6;
    }

    h5 {
      color: #c6c6c6;
    }

    .find {
      div {
        input {
          background: #507383 !important;
          border: none !important;
          color: white !important;
        }

        input::-webkit-input-placeholder {
          color: white !important;
        }
      }

      .findBox {
        border: 1px solid #507383 !important;

        li {
          color: white !important;
        }
      }
    }

    .addTerm {
      input {
        background: #507383 !important;
        border: none !important;
        color: white !important;
      }

      input::-webkit-input-placeholder {
        color: white !important;
      }
    }

    button {
      background: #507383 !important;
      color: white !important;
      border: none !important;
    }

    button:hover {
      background: #405964 !important;
    }

    button:active {
      background: #2c4753 !important;
    }
  }

  /deep/ .el-select {
    /deep/ .el-input__inner {
      background: #507383 !important;
      border: none !important;
      color: white !important;
    }
  }

  /deep/ .el-button {
    background: #507383 !important;
    border: none !important;
    color: white !important;
  }
}

.mystyle {
  box-shadow: 2px 5px 2px 0 rgba(102, 102, 102, 0.5) !important;
  font-size: 18px;
}

.main {
  height: 100%;
  background: url("~@/assets/imgs/editor/background.png") no-repeat;
  background-size: cover;
  .editor-header-top {
    height: 60px;
    // background: rgba(255, 255, 255, 1);
  }
  .el-select {
    float: left;
    margin-left: 30px;
  }

  /deep/ .el-input__inner {
    height: 32px;
    line-height: 32px;
  }
}

.box {
  width: calc(100% - 360px);
  margin-left: 20px;
  float: left;
  /*overflow-y: auto;*/
  height: 100%;
  position: relative;
  z-index: 5;

  .riBoxSw {
    position: absolute;
    top: 50%;
    right: 0;
    z-index: 100;
    font-size: 24px;
    transform: translateY(-50%);
    cursor: pointer;
  }
}

.rigContantBox {
  float: right;
  width: 300px;
  height: 100%;
  margin-right: 20px;
  position: relative;

  .riBoxSw {
    position: absolute;
    top: 50%;
    height: 50px;
    width: 13px;
    left: -21px;
    z-index: 30;
    font-size: 24px;
    transform: translateY(-50%);
    cursor: pointer;
  }

  .icon-left {
    background: url("~@/assets/imgs/editor/zhankai_normal.png") no-repeat;
  }

  .icon-left:active {
    background: url("~@/assets/imgs/editor/zhankai_press.png") no-repeat;
  }

  .icon-right {
    background: url("~@/assets/imgs/editor/shouqi_normal.png") no-repeat;
  }

  .icon-right:active {
    background: url("~@/assets/imgs/editor/shouqi_press.png") no-repeat;
  }
}

.operationBox {
  width: 100%;
  height: 100%;
  overflow: auto;
  background: #fff;
  padding: 5px 0;
  box-sizing: border-box;

  .termTit {
    margin-left: 20px;
    width: 80%;
  }

  .operation {
    display: flex;
    justify-content: center;
    flex-wrap: wrap;

    .addTerm {
      display: flex;
      flex-wrap: wrap;
      width: 100%;
      justify-content: center;
      padding: 0 20px;

      .sourceInput {
        height: 34px;
        line-height: 36px;
        border: 1px solid rgba(187, 187, 187, 1);
        border-radius: 4px;
        padding: 0 10px;
        margin-bottom: 10px;
        width: 100%;
      }

      .sourceInput:focus {
        outline: none;
        border: 1px solid #454545;
      }

      .addBox {
        width: 100%;

        .targetInput {
          width: 50%;
          height: 34px;
          line-height: 36px;
          border: 1px solid rgba(187, 187, 187, 1);
          border-radius: 4px;
          padding: 0 10px;
        }

        .targetInput:focus {
          outline: none;
          border: 1px solid #454545;
        }

        button {
          width: 33%;
          height: 34px;
          background: rgba(69, 69, 69, 1);
          border-radius: 4px;
          border: 0px;
          font-size: 14px;
          color: rgba(255, 255, 255, 1);
          float: right;
          padding: 0;
        }
      }
    }

    .find {
      width: 100%;
      margin-top: 20px;
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
      position: relative;
      padding: 0 20px;

      div {
        position: relative;
        width: 100%;
        margin: 0 auto;
        display: flex;
        justify-content: center;

        input {
          //  float: right;
          width: 100%;
          height: 34px;
          line-height: 36px;
          border: 1px solid rgba(187, 187, 187, 1);
          border-radius: 4px;
          padding: 0 10px 0 26px;
        }

        .search {
          position: absolute;
          right: 3%;
          top: 10px;
          cursor: pointer;
        }
      }

      .findBox {
        min-height: 50px;
        max-height: 180px;
        width: 100%;
        border: 1px solid rgba(187, 187, 187, 1);
        border-radius: 4px;
        text-align: left;
        padding: 10px;
        overflow: auto;

        li {
          padding: 3px 0;

          span {
            font-weight: 700;
          }
        }
      }

      h5 {
        margin: 10px 0;
        text-align: left;
        width: 100%;
      }
    }
  }

  .hint::-webkit-scrollbar {
    width: 0 !important;
  }

  .hint {
    max-height: 160px;
    overflow: auto;
    -ms-overflow-style: none;
    overflow: -moz-scrollbars-none;

    li {
      margin: 0 20px;

      p {
        word-wrap: break-word;
        word-break: normal;
      }
    }
  }

  h4 {
    text-align: left;
    margin-top: 20px;
    margin-left: 20px;
    font-size: 18px;
    font-weight: bold;
    color: rgba(34, 34, 34, 1);

    h3 {
      width: 4px;
      height: 18px;
      background: rgba(69, 69, 69, 1);
      float: left;
      margin-right: 15px;
      position: relative;
      top: 4px;
      font-size: 16px;
      font-weight: 400;
      color: rgba(34, 34, 34, 1);
    }
  }

  h5 {
    font-size: 16px;
    font-weight: bold;
    color: rgba(34, 34, 34, 1);
    margin: 20px 0;
    width: 100%;
    text-align: left;
  }
}

.lefBag {
  position: absolute;
  left: 0;
  top: 0;
  height: 100%;
  overflow-x: hidden;
  overflow-y: scroll;
  float: left;
  background: #fff;
  width: 47%;
}

.lefBag::-webkit-scrollbar {
  display: none;
}

.rig {
  min-height: 760px;
  position: relative;
  height: 760px;
  overflow: auto;
  width: 47%;
  float: right;
  background: #fff;
  padding: 20px;
  z-index: 50;
}

.cen {
  position: absolute;
  height: 54%;
  left: 50%;
  transform: translateX(-50%);
  overflow: auto;
  width: 100%;
  margin: 0 auto;
  background: #fff;
  padding: 20px;
  z-index: 50;
  box-sizing: border-box;

  .translationBox {
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
  }

  .shade {
    position: absolute;
    height: 100%;
    width: 100%;
    z-index: 10;
    left: 0;
    top: 0;
  }

  iframe {
    position: absolute;
    z-index: 20;
    left: 0;
    top: 0;
    padding: 10px;
    box-sizing: border-box;
  }
}

.tab {
  width: 100% !important;
  height: 100%;
  overflow: hidden;
  margin: 0 auto;

  .cell {
    i {
      width: 18px;
      height: 18px;
      margin: 0 auto;
      display: block;
    }

    .modify {
      background: url("~@/assets/imgs/editor/bianji.png") center center
        no-repeat;
    }

    .confirm {
      background: url("~@/assets/imgs/editor/right.png") center center no-repeat;
    }

    .lock {
      background: url("~@/assets/imgs/editor/suo.png") center center no-repeat;
    }

    .updateBox {
      cursor: pointer;
      background: url("~@/assets/imgs/editor/ckbz_normal.png") center center
        no-repeat;
    }

    .updateBox:active {
      background: url("~@/assets/imgs/editor/ckbz_press.png") center center
        no-repeat;
    }

    .addBox {
      cursor: pointer;
      background: url("~@/assets/imgs/editor/tjbz_normal.png") center center
        no-repeat;
    }

    .addBox:active {
      background: url("~@/assets/imgs/editor/tjbz_press.png") center center
        no-repeat;
    }

    .el-icon-more-outline {
      font-size: 20px;
      cursor: pointer;
    }
  }
}

.pptTab {
  /deep/ .el-table__header-wrapper {
    cursor: s-resize;
  }
}

span:focus {
  outline: -webkit-focus-ring-color auto 0px !important;
}

#WordBox {
  position: absolute;
  padding: 5px;
  z-index: 1000;
  border-radius: 5px;
  background: #666666;
  color: #fff;
}
</style>

<style lang="less">
#tabBox {
  .loading {
    position: fixed;
    width: 100%;
    height: 100%;
    background: red;
    z-index: 10;
    .cell {
      overflow: hidden;
      box-sizing: border-box;
      height: 100%;
      position: relative;
      span {
        font-size: 20px;
        width: 100%;
        height: 100%;
        display: inline-block;
        line-height: 100%;
      }
      i {
        width: 100%;
        height: 100%;
        display: inline-block;
      }
    }
  }
}
</style>
